import "./styles.css"

export function Tag({ data }: { data: string[] }) {
  if (data.length === 0) return null
  return (
    <ul className="column">
      {data.map((tag) => (
        <li
          className="tag"
          key={tag}
        >
          {tag}
        </li>
      ))}
    </ul>
  )
}

export default Tag
